export default {
	email: 'Email nouvel utilisateur principal',
	ceder: 'Céder les SIRETS'
};
